import DefaultLayout from "components/layouts/DefaultLayout"
import Spinner from "components/styled/Spinner"
import Breadcrumbs from "components/layouts/Breadcrumbs"

export default function LoadingScene() {
  return (
    <DefaultLayout page="loading">
      <Breadcrumbs page="loading" items={[]} />
      <Spinner />
    </DefaultLayout>
  )
}
